import { Entity, IEntity } from "../entity";
import { ILocation } from "./geocodingInfo";

export interface IOrganizationMap extends IEntity {
  id: string;
  name: string;
  type: string;
  website: string;
  location: ILocation;
  postalCode: string;
  locality: string;
  province: string;
}

export class OrganizationMap extends Entity implements IOrganizationMap {
  name: string;
  type: string;
  website: string;
  location: ILocation;
  postalCode: string;
  locality: string;
  province: string;

  constructor(data: IOrganizationMap) {
    super(data);
    this.name = data.name;
    this.type = data.type;
    this.website = data.website;
    this.location = data.location;
    this.postalCode = data.postalCode;
    this.locality = data.locality;
    this.province = data.province;
  }
}
